// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"iF","logoWrapper":"iG"};